import { render, staticRenderFns } from "./EmergenzaList.vue?vue&type=template&id=20eacd94"
import script from "./EmergenzaList.vue?vue&type=script&lang=js"
export * from "./EmergenzaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports